import { useContext } from "react";

import CartContext from "../context/CartProvider.context";

import type { UseCartContextType } from "@/context/CartProvider.context";

const useCart = (): UseCartContextType => useContext(CartContext);

export default useCart;
